'use strict';
// Pure mapping: a SEEDED answer's coverage status → a short decision-support flag
// for the field-context rail, so the clinician sees WHY the suggested code does or
// does not satisfy medical necessity for THIS test. The flag names the EXACT factor
// (the code + the test) rather than a generic note.
//
// Returns null when there is nothing to say (status absent, not_checked, or no code)
// so the rail renders no flag at all. NEVER throws.
//
// CommonJS (Jest has no ESM transform); imported by field-context-rail.jsx and
// bundled by esbuild. Status vocabulary mirrors labCoverage.resolveCoverage:
//   'covered' | 'no_med_nec' | 'denied' | 'not_listed' | 'not_checked'.
function coverageFlagText(status, code, testLabel) {
  const c = code != null ? String(code).trim() : '';
  const t = (typeof testLabel === 'string' && testLabel.trim()) || 'this test';
  if (!status || !c) return null;
  switch (String(status)) {
    case 'covered':
      return { tone: 'ok', text: `✓ ${c} is a covered indication for ${t}.` };
    case 'not_listed':
      // SOFT: the coverage table is the CMS NATIONAL NCD floor only — it does not
      // contain local LCD-covered indications, so "not on the national list" must
      // NOT be stated as a definitive failure. Mirror the muted field coverageChip
      // ("not confirmed", not "will not satisfy"). Also avoid promising a list
      // "below" (the covered-options list may legitimately be empty); search is
      // always available, so point there too.
      return {
        tone: 'warn',
        text: `⚠ ${c} is not on the CMS national covered list for ${t} — it may not satisfy Medicare medical necessity. Verify the policy, or choose a covered diagnosis.`,
      };
    case 'no_med_nec':
      return {
        tone: 'warn',
        text: `⚠ ${c} does not establish medical necessity for ${t} on its own — confirm or choose a covered diagnosis.`,
      };
    case 'denied':
      // Explicit negative NCD row → the hard wording is warranted here.
      return {
        tone: 'danger',
        text: `⛔ ${c} is not supportive of medical necessity for ${t} — choose a covered diagnosis.`,
      };
    default:
      return null; // not_checked / unknown → no flag
  }
}

module.exports = { coverageFlagText };
